import styled from 'styled-components';
import { designTokens } from '../foundation/DesignTokens';

// Main container for the entire settings view
export const TabsContainer = styled.div`
  height: ${(props) => (props.initWhatsappTemplateView ? "90%" : "95%")};
  display: flex;
  flex-direction: column;
  background: ${designTokens.colors.gray[50]};
  font-family: ${designTokens.fonts.body};
`;

// Container for the tab navigation pills
export const TabsNavigation = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: ${designTokens.radius.full};
  background: ${designTokens.colors.gray[100]};
  margin-bottom: ${designTokens.spacing.xl};
  width: fit-content;

  @media (max-width: 900px) {
    width: 100%;
    overflow-x: auto;
    flex-wrap: nowrap;
    gap: 2px;
    padding: 2px;
  }
`;

// Individual tab pill component
export const TabPill = styled.button`
  border-radius: ${designTokens.radius.full};
  padding: 6px 12px;
  font-size: 0.78rem;
  border: none;
  background: transparent;
  color: ${designTokens.colors.gray[600]};
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  font-family: ${designTokens.fonts.body};
  font-weight: 500;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }

  ${(props) =>
    props.active &&
    `
    background: white;
    color: ${designTokens.colors.primary[600]};
    box-shadow: ${designTokens.shadows.sm};
    font-weight: 600;
  `}

  @media (max-width: 1200px) {
    font-size: 0.75rem;
    padding: 5px 10px;
  }

  @media (max-width: 900px) {
    font-size: 0.7rem;
    padding: 4px 8px;
    min-width: fit-content;
  }

  @media (max-width: 600px) {
    font-size: 0.65rem;
    padding: 3px 6px;
  }
`;

// Content area for tab panels
export const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0;
  background: transparent;

  @media (max-width: 900px) {
    padding: 0;
  }
`;

// Header section for the settings page
export const SettingsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${designTokens.spacing.xl};
  padding: 0 ${designTokens.spacing.sm};

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${designTokens.spacing.md};
    margin-bottom: ${designTokens.spacing.lg};
  }
`;

// Title for the settings page
export const SettingsTitle = styled.h1`
  font-family: ${designTokens.fonts.heading};
  font-weight: 800;
  font-size: 1.25rem;
  color: ${designTokens.colors.gray[900]};
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${designTokens.spacing.sm};

  @media (max-width: 900px) {
    font-size: 1.1rem;
  }
`;

// Badge/tag component for the settings title
export const SettingsBadge = styled.span`
  padding: 4px 10px;
  border-radius: ${designTokens.radius.full};
  background: ${designTokens.colors.gray[100]};
  color: ${designTokens.colors.gray[600]};
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-family: ${designTokens.fonts.body};
`;

// Main content wrapper
export const SettingsContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 ${designTokens.spacing.sm};

  @media (max-width: 900px) {
    padding: 0;
  }
`;
